import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { api } from "@/lib/api-client"
import type { TicketType } from "@/lib/types"

export function useTicketTypes() {
  return useQuery({
    queryKey: ["ticket_types"],
    queryFn: () => api.get<{ data: TicketType[] }>("/api/v1/ticket_types"),
  })
}

export function useTicketType(id?: string) {
  return useQuery({
    queryKey: ["ticket_types", id],
    queryFn: () => api.get<{ data: TicketType }>(`/api/v1/ticket_types/${id}`),
    enabled: !!id,
  })
}

export function useCreateTicketType() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: Record<string, unknown>) =>
      api.post<{ data: TicketType }>("/api/v1/ticket_types", data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["ticket_types"] }),
  })
}

export function useUpdateTicketType() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Record<string, unknown> }) =>
      api.patch<{ data: TicketType }>(`/api/v1/ticket_types/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["ticket_types"] }),
  })
}

export function useDeleteTicketType() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.delete(`/api/v1/ticket_types/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["ticket_types"] }),
  })
}
